<div class="keyboard-hints d-flex align-items-center gap-3 flex-wrap">
  <span class="keyboard-hints__item d-flex align-items-center gap-1">
    <kbd>↑</kbd><kbd>↓</kbd>
    <span class="keyboard-hints__label">Navigate</span>
  </span>

  <span class="keyboard-hints__item d-flex align-items-center gap-1">
    <kbd>↵</kbd>
    <span class="keyboard-hints__label">Select</span>
  </span>

  <span class="keyboard-hints__item d-flex align-items-center gap-1">
    <kbd>Tab</kbd>
    <span class="keyboard-hints__label">Scope</span>
  </span>

  <span class="keyboard-hints__spacer ms-auto d-flex align-items-center gap-2">
    <kbd>Esc</kbd>
    <button
      type="button"
      class="keyboard-hints__close button-no-style text-sm fw-500"
      aria-label="Close search"
      (click)="close.emit()"
    >
      Close
    </button>
  </span>
</div>
